<div class="layout-wrapper" [class.has-environment-banner]="!environment.production" [ngClass]="containerClass">
    <div
        *ngIf="!environment.production"
        class="environment-banner"
        [attr.aria-label]="'Ambiente ' + environment.name"
    >
        <i class="pi pi-exclamation-triangle"></i>
        <span>AMBIENTE {{ environment.name }}</span>
    </div>
    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <div class="layout-mask animate-fadein"></div>
</div>
